import { Link } from 'react-router-dom';
import { CheckCircleIcon } from '@heroicons/react/24/outline';
import Navbar from '../components/Navbar';

export default function SupportThankYouPage() {
  return (
    <div className="min-h-screen bg-gray-50">
      <Navbar />
      
      <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
        <div className="bg-white rounded-lg shadow-sm p-8 text-center">
          <CheckCircleIcon className="h-16 w-16 text-green-500 mx-auto mb-4" />
          
          <h1 className="text-3xl font-bold text-gray-900 mb-4">
            Thank You for Contacting Support
          </h1>
          
          <p className="text-lg text-gray-600 mb-8">
            We've received your support request and will get back to you within 24 business hours.
          </p>
          
          <div className="bg-gray-50 rounded-lg p-6 mb-8">
            <h2 className="text-lg font-semibold text-gray-900 mb-2">
              What happens next?
            </h2>
            <ul className="text-left space-y-2 text-gray-600">
              <li className="flex items-start">
                <span className="text-blue-600 mr-2">1.</span>
                You'll receive an email confirmation with your ticket number
              </li>
              <li className="flex items-start">
                <span className="text-blue-600 mr-2">2.</span>
                Our support team will review your request
              </li>
              <li className="flex items-start">
                <span className="text-blue-600 mr-2">3.</span>
                We'll respond with a solution or follow-up questions
              </li>
            </ul>
          </div>
          
          <div className="space-y-4">
            <p className="text-gray-600">
              While you wait, you might find answers in our:
            </p>
            
            <div className="flex flex-col sm:flex-row gap-4 justify-center">
              <Link
                to="/help"
                className="inline-flex items-center justify-center px-6 py-3 border border-gray-300 text-base font-medium rounded-md text-gray-700 bg-white hover:bg-gray-50"
              >
                Knowledge Base
              </Link>
              <Link
                to="/help/best-practices"
                className="inline-flex items-center justify-center px-6 py-3 border border-transparent text-base font-medium rounded-md text-white bg-blue-600 hover:bg-blue-700"
              >
                Best Practices
              </Link>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}